import CountryPageRenderer from '../components/CountryPageRenderer';
import estoniaData from '../data/country-pages/estonia';

export default function EstoniaCountryPage() {
  return <CountryPageRenderer data={estoniaData} />;
}
